import { Flex, FlexProps } from '@ui-library/misc';
import { FixMe } from '@utils/types';
import styled from 'styled-components';
import { is } from 'typescript-styled-is';

const colors = {
  bracket: '#c4353f',
  string: '#5299da',
  typeKey: '#eca46c',
  number: '#eca46c',
  default: '#6C757D',
  null: '#034efc',
  boolean: '#034efc',
};

export const JsonViewWrapper = styled<FixMe>(Flex)<FlexProps>`
  border: 1px solid #dedede;
  background-color: #ffffff;
  border-radius: 6px;
  color: #6c757d;
  max-height: 340px;
  min-height: 340px;
  overflow: auto;
  width: 100%;
`;
export const JSONHeader = styled<FixMe>(Flex)<FlexProps>`
  height: 32px;
  margin-bottom: 12px;
`;

export const JsonViewMain = styled<FixMe>(Flex)<FlexProps>`
  height: 100%;
  width: 100%;
  min-height: 340px;
`;

// line count
export const LineCountWrapper = styled.div`
  padding: 8px 8px 8px 50px;
  background-color: #f7f9fa;
  border-right: 1px solid #eaeced;
  min-height: 340px;
`;
export const ColoredValue = styled.span<{
  type?: keyof typeof colors;
  renamed?: boolean;
}>`
  color: ${(props) => colors[props.type || 'default'] || colors.default};
  ${is('renamed')`
  background-color: #f7f9fa;
`}
  ${(props) =>
    props.type === 'string' &&
    `
    &:before{
      content:"'";
    }
    &:after{
      content:"'";
    }
 
  `}
`;
// json data view
export const JsonDataWrapper = styled.div`
  padding: 8px 50px 8px 10px;
  width: 100%;
  max-width: 600px;
  overflow-y: auto;
`;
